module.exports = __webpack_public_path__ + "static/media/bs.524a1ab5.svg";